module.exports = __webpack_public_path__ + "static/img/10.e8be857c.png";